import { TimelineElement } from "@/src/types";
import foret1 from "../../images/foret1.jpg";
import gmaps from "../../images/gmaps.jpg";
import wallpaper from "../../images/wallpaper.png";
import history from "../../images/historty.png";
import map from "../../images/map-details.png";

import { TimelineLayout } from "../Timeline";
import { Button } from "../ui/button";
import { Link } from "react-router-dom";

const GemapiRuDeMarivel = () => {
  const timelineData = [
    {
      id: 1,
      title: "XXe siècle",
      icon: "4",
      description:
        "Le ru est presque entièrement canalisé et enterré, devenant partie intégrante du réseau d'assainissement. Des inondations occasionnelles rappellent toutefois sa présence.",
    },
    {
      id: 2,
      title: "XIXe siècle",
      icon: "3",
      description:
        "L'industrialisation et l'urbanisation croissante conduisent aux premiers travaux d'enfouissement du ru, notamment avec l'arrivée du chemin de fer dans la vallée.",
    },
    {
      id: 3,
      title: "XVIIe siècle",
      icon: "2",
      description:
        "Avec la construction du château de Versailles, le ru est partiellement détourné pour alimenter les fontaines et bassins des jardins royaux.",
    },
    {
      id: 4,
      title: "Moyen Âge",
      icon: "1",
      description:
        "Le ru de Marivel est utilisé comme source d'eau pour les villages environnants et alimente plusieurs moulins le long de son cours.",
    },
  ];

  return (
    <div>
      <div className="container px-4 mx-auto mt-20 mb-10 sm:px-6 lg:px-8">
        <div className="p-2 mt-4 sm:p-3">
          <h1 className="text-xl font-bold text-center text-black">
            Présentation
          </h1>
        </div>

        <div className="grid items-center grid-cols-1 gap-6 mt-6 md:grid-cols-2 sm:mt-8">
          <div className="text-start">
            <p className="text-base">
              Le ru de Marivel prend sa source à Versailles, dans le quartier de
              Porchefontaine. Il se jette dans la Seine non loin du pont de
              Sèvres. Ancien cours d’eau prenant sa source non loin du château
              de Versailles, le ru de Marivel dévalait tranquillement les
              quelques 140 mètres de dénivellation de la vallée qui porte son
              nom, jusqu’à la Seine. Les vidanges et gadoues des riverains
              étaient stockées dans des bassins où les matières solides
              décantaient et les liquides s’évaporaient.
            </p>
            <p className="mt-4 text-base">
              Malheureusement, ces volumes allant croissant avec l’augmentation
              de la population, il vint à l’esprit des gestionnaires de les
              déverser dans l’eau du ru. Quel ne fut pas l’émoi des riverains de
              voir les belles eaux claires et vives se transformer
              épisodiquement en égout à ciel ouvert. La nécessité de faire face
              à ce problème conduisit à la réalisation d’un premier égout, dès
              l’époque du Directoire, ancêtre du réseau actuel.
            </p>
          </div>
          <div className="flex justify-center">
            <img
              src={foret1}
              alt="Ru de Marivel landscape"
              className="w-full h-auto max-w-xs rounded-lg sm:max-w-sm"
            />
          </div>
        </div>

        <div className="p-2 mt-8 sm:p-3 sm:mt-10">
          <h1 className="text-xl font-bold text-center text-black">
            Géographie
          </h1>
        </div>

        <div className="grid items-center grid-cols-1 gap-6 mt-6 md:grid-cols-2 sm:mt-8">
          <div className="text-start">
            <h2 className="text-xl font-bold text-black">
              La vallée du Marivel
            </h2>
            <p className="mt-2 text-base">
              Le ru de Marivel s'écoule dans une vallée caractéristique, bordée
              de versants aux pentes douces. Son bassin versant s'étend sur
              plusieurs communes des Hauts-de-Seine et des Yvelines, incluant
              Versailles, Viroflay, Chaville, Sèvres et Ville-d'Avray.
            </p>
            <p className="mt-4 text-base">
              Plusieurs affluents, souvent de petits ruisseaux saisonniers,
              viennent alimenter son cours principal, créant un réseau
              hydrographique complexe qui a façonné le paysage local.
            </p>
          </div>
          <div className="flex justify-center">
            <img
              src={gmaps}
              alt="Map of Marivel valley"
              className="w-full h-auto max-w-xs rounded-lg sm:max-w-sm"
            />
          </div>
        </div>
      </div>

      <section
        className="w-full min-h-[50vh] sm:min-h-[60vh] p-4 sm:p-6 md:p-10 lg:p-20 text-center bg-blend-overlay"
        style={{
          backgroundImage: `url(${wallpaper})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <h1 className="text-xl font-bold text-center text-black sm:text-2xl md:text-3xl">
          Une rivière au cœur de l'Histoire
        </h1>
        <div className="flex justify-center mt-4 sm:mt-6">
          <TimelineLayout
            items={timelineData as TimelineElement[]}
            size="md"
            className="w-full max-w-3xl"
          />
        </div>
      </section>

      <div className="container px-4 mx-auto mt-10 mb-10 sm:px-6 lg:px-8">
        <div className="grid items-center grid-cols-1 gap-6 mt-6 md:grid-cols-2 sm:mt-8">
          <div className="text-start">
            <p className="text-base">
              Le réseau de transport du SIAVRM est organisé autour d’un axe
              central de transport des effluents qui suit le tracé de la voirie
              départementale qui relie Versailles à Sèvres (RD 10 sur le
              département des Yvelines et RD 910 sur le département des Hauts de
              Seine). Il est complété par deux antennes latérales, en direction
              de Ville d’Avray et Marnes la Coquette d’une part (Nord Ouest), de
              Chaville et Vélizy d’autre part (Sud).
            </p>
            <p className="mt-4 text-base">
              L’évolution des capacités de transport du réseau du SIAVRM a dû
              suivre l’extension progressive de l’urbanisation à des zones
              anciennement rurales sur le bassin versant. Sur un siècle,
              l’imperméabilisation du bassin versant du ru de Marivel a été
              radicalement modifiée.
            </p>
          </div>
          <div className="flex justify-center">
            <img
              src={history}
              alt="Historical development of SIAVRM network"
              className="w-full h-auto max-w-xs rounded-lg sm:max-w-sm"
            />
          </div>
        </div>
        <div className="flex justify-center mt-6 sm:mt-8">
          <Link to="/gemapi/historique-ru-marivel">
            <Button>Voir toute l’évolution</Button>
          </Link>
        </div>

        <div className="mt-8 sm:mt-10">
          <h2 className="text-xl font-bold text-center text-black">
            Aménagements
          </h2>
          <div className="mt-4 rounded-lg sm:mt-6 bg-secondary/10">
            <p className="p-4 text-base text-center text-black sm:p-6">
              Aujourd’hui, le ru de Marivel est entièrement couvert. La
              Nationale 10 passe au-dessus.
            </p>
          </div>
        </div>

        <div className="mt-8 sm:mt-10">
          <h2 className="text-xl font-bold text-center text-black">
            Les Collecteurs du Ru de Marivel
          </h2>
          <div className="mt-4 sm:mt-6">
            <div className="overflow-hidden rounded-lg">
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 sm:gap-6">
                <div className="p-4 border-l border-gray-200 sm:p-6 border-primary">
                  <h3 className="mb-2 text-base font-semibold text-black">
                    Collecteur A
                  </h3>
                  <p className="text-base text-black">
                    Construit au XIXe siècle, ce collecteur principal suit le
                    tracé historique du ru depuis Versailles jusqu'à Sèvres.
                  </p>
                  <p className="mt-2 text-base text-neutral-400">
                    Date de construction : 1865-1870
                  </p>
                </div>
                <div className="p-4 border-l border-gray-200 sm:p-6 border-primary">
                  <h3 className="mb-2 text-base font-semibold text-black">
                    Collecteur B
                  </h3>
                  <p className="text-base text-black">
                    Collecteur secondaire drainant les eaux du versant nord de
                    la vallée, notamment depuis Ville-d'Avray.
                  </p>
                  <p className="mt-2 text-base text-neutral-400">
                    Date de construction : 1885-1890
                  </p>
                </div>
                <div className="p-4 border-l border-gray-200 sm:p-6 border-primary">
                  <h3 className="mb-2 text-base font-semibold text-black">
                    Collecteur D
                  </h3>
                  <p className="text-base text-black">
                    Aménagé pour recueillir les eaux du plateau de Vélizy et du
                    sud de Chaville.
                  </p>
                  <p className="mt-2 text-base text-neutral-400">
                    Date de construction : 1910-1915
                  </p>
                </div>
                <div className="p-4 border-l border-gray-200 sm:p-6 border-primary">
                  <h3 className="mb-2 text-base font-semibold text-black">
                    Collecteur J
                  </h3>
                  <p className="text-base text-black">
                    Le plus récent des collecteurs majeurs, construit pour
                    renforcer le réseau face à l'urbanisation croissante.
                  </p>
                  <p className="mt-2 text-base text-neutral-400">
                    Date de construction : 1950-1955
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-6 sm:mt-8">
          <Link to="/gemapi/collecteurs-ru-marivel">
            <Button>Plus d’informations</Button>
          </Link>
        </div>

        {/*<div className="mt-8 sm:mt-10">
          <img
            src={map}
            alt="Map of Ru de Marivel collectors"
            className="w-full h-auto max-w-4xl mx-auto rounded-lg"
          />
        </div>*/}
      </div>
    </div>
  );
};

export default GemapiRuDeMarivel;
